import {
    GET_ALL_TESTS_FAIL,
    GET_ALL_TESTS_REQUEST,
    GET_ALL_TESTS_SUCCESS
} from "../constants/testConstants"

export const getTestMergeReducer = (state = { }, action) => {
    switch(action.type) {
        case GET_ALL_TESTS_REQUEST:
            return { loading:true }

        case GET_ALL_TESTS_SUCCESS:
            return { loading:false, text: action.payload }

        case GET_ALL_TESTS_FAIL:
            return { loading:false, error: action.payload }

        default:
            return state
    }
}
